export function CustomRadio({ ...props }) {
    return (
        <input
            type="radio"
            className="relative size-4 cursor-pointer appearance-none rounded-full border-1 border-primaryText before:absolute before:left-[3px] before:top-[3px] before:m-auto before:block before:size-2 before:rounded-full before:transition-all before:content-[''] checked:border-primaryBg checked:bg-primaryBg checked:before:bg-white"
            {...props}
        />
    )
}
